<template>
  <div></div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "DownloadExport",

  created: function () {
    this.getDownloadLink(this.$route.params.dlid);
  },
  computed: {
    link: function () {
      return this.$store.state.backend_data.downloadlink;
    },
  },
  watch: {
    link(link) {
      if (link) this.send_file_to_user();
    },
  },
  methods: {
    ...mapActions(["getDownloadLink"]),
    send_file_to_user: async function () {
      if (!this.link) return;
      const response = await fetch(this.link.url);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "export.xlsx";
      document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
      a.click();
      a.remove(); //afterwards we remove the element again
    },
  },
};
</script>